import { AxiosResponse } from "axios";
import { KeyValueDefault } from "../models/common";
import { Result } from "../models/common/resultResponse";
import { IIntegrationTriggerApi } from "./base";
import { api } from "./base/api";

const baseRoute: string = "IntegrationTrigger";

export class IntegrationTriggerApi extends IIntegrationTriggerApi {
	getDomain(): Promise<AxiosResponse<Result<KeyValueDefault[]>>> {
		return api.get(`${baseRoute}/domain`);
	}
}
